// src/components/tour/tours/auditLog.jsx
//
// Audit Log tour (internal admins). ctx is registered in AuditLog.jsx.

import React from 'react';
import { replayStep } from './common';

const Tier = ({ tier, children }) => <span className={`aud-tier-chip ${tier}`}>{children}</span>;

export function getAuditLogSteps(ctx, env) {
    const { total = 0, tierCounts = {}, firstLog } = ctx;
    const { isMobile } = env;

    return [
        {
            target: null,
            title: 'Welcome to the Audit Log',
            content: (
                <p>
                    A record of who changed what, and when: logins, accounts, devices, caps, priorities and more,
                    from both your team and clients. <span className="pt-data">{total}</span> record{total === 1 ? '' : 's'} so far.
                </p>
            ),
        },
        {
            target: '[data-tour="au-filters"]',
            title: 'Find a record',
            content: isMobile ? (
                <p>Search by user, IP or serial. <b>FILTERS</b> adds action type and a date range.</p>
            ) : (
                <p>
                    Filter by action type, search by user, IP, serial or details, and pick a date range, then
                    press <b>Apply filters</b>. <b>EXPORT CSV</b> downloads what's listed.
                </p>
            ),
        },
        {
            target: '[data-tour="au-activity"]',
            title: 'Three levels',
            content: (
                <>
                    <p>Every action is tagged by how much it matters:</p>
                    <p>
                        <Tier tier="routine">ROUTINE</Tier> day-to-day (logins, verifications){!isMobile && <> · <span className="pt-data">{tierCounts.routine ?? 0}</span> on this page</>},{' '}
                        <Tier tier="config">CONFIG</Tier> changes to behaviour or limits (caps, priorities, alerts){!isMobile && <> · <span className="pt-data">{tierCounts.config ?? 0}</span></>},{' '}
                        <Tier tier="security">SECURITY</Tier> deletions and password resets{!isMobile && <> · <span className="pt-data">{tierCounts.security ?? 0}</span></>}.
                    </p>
                </>
            ),
        },
        {
            target: '[data-tour="au-first"]',
            title: 'Reading a record',
            content: firstLog ? (
                <>
                    <p>The latest one: <Tier tier={firstLog.tier}>{firstLog.label}</Tier>.</p>
                    <p>
                        {isMobile
                            ? 'Each card shows the action, time, details, and the serial or client plus the IP it came from.'
                            : <>Each row shows the time, action, details, device serial, who did it (<b>C</b> = client ID, <b>U</b> = user ID) and their IP address.</>}
                    </p>
                </>
            ) : null,
        },
        replayStep,
    ];
}
